import { useMemo } from 'react';

import { useThemeContext } from '../../theme/context/ThemeContext';
import { switch_dark_theme } from '../constants';
import { SwitchTheme, SwitchThemePartial } from '../types';

export const useSwitchTheme = (theme: SwitchThemePartial = switch_dark_theme): SwitchTheme => {
  const {
    theme: {
      switch: { general, background },
    },
  } = useThemeContext();

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      background: { ...background, ...theme.background },
    }),
    [theme, general, background]
  );
};
